import { DEBUG_BUILD } from './debug-build.js';
import { GLOBAL_OBJ } from './worldwide.js';

/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'];

/** This may be mutated by the console instrumentation. */
var originalConsoleMethods = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!('console' in GLOBAL_OBJ)) {
    return callback();
  }
  var console = GLOBAL_OBJ.console;
  var wrappedFuncs = {};
  var wrappedLevels = Object.keys(originalConsoleMethods);

  // Restore all wrapped console methods
  wrappedLevels.forEach(function (level) {
    var originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console[level];
    console[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(function (level) {
      console[level] = wrappedFuncs[level];
    });
  }
}
function makeLogger() {
  var enabled = false;
  var logger = {
    enable: function enable() {
      enabled = true;
    },
    disable: function disable() {
      enabled = false;
    },
    isEnabled: function isEnabled() {
      return enabled;
    }
  };
  if (DEBUG_BUILD) {
    CONSOLE_LEVELS.forEach(function (name) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (enabled) {
          consoleSandbox(function () {
            var _GLOBAL_OBJ$console;
            (_GLOBAL_OBJ$console = GLOBAL_OBJ.console)[name].apply(_GLOBAL_OBJ$console, ["".concat(PREFIX, "[").concat(name, "]:")].concat(args));
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(function (name) {
      logger[name] = function () {
        return undefined;
      };
    });
  }
  return logger;
}
var logger = makeLogger();
export { CONSOLE_LEVELS, consoleSandbox, logger, originalConsoleMethods };